export function singleHandlerFactory(eventName, handlerFactory) {
  let singleHandlerCounter = 0;

  return (handler) => {
    if (singleHandlerCounter === 1) {
      throw new Error(`Attempt to listen the same event ${eventName}`);
    }
    const off = handlerFactory(eventName, handler);
    singleHandlerCounter++;

    return () => {
      off();
      if (singleHandlerCounter === 0) {
        throw new Error('Incorrect counter');
      }
      singleHandlerCounter--;
    };
  };
}
